/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import React, { Fragment, useEffect, useState, useRef } from "react";
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Lazy,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle";
import "./Storedetail.css";

import { Box } from "@mui/material";

import Storecard from "../../components/cards/Storecard";
import altar from "../../assets/store/altarchest.jpg";
import { getChestHunter } from "../../store/Store/actions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Address from "../../hooks/Getaddress";
import greenButton from "../../assets/store/greenButton.png";

import backgroundchest from "../../assets/store/background-chest.png";
import buybutton from "../../assets/store/buynow.png";
import tier2 from "../../assets/store/tier2.png";
import tier3 from "../../assets/store/tier3.png";
import config from "../../config";
import axios from "axios";
import { ethers } from "ethers";
import { openChestAndGetHunter } from "../../chain/chest";
import {
  IncrementPendingHunters,
  SetPendingHunters,
} from "../../store/Items/actions";
import { LOCAL_COUNT_KEY } from "../../chain/chainConfig";
import { useSequenceWalletConnect } from "../../context";
import getWallet from "../../chain/sequenceWallet";
import counter from "../../assets/store/chestCounter.png";
import { decreaseChestCount, getChestCount } from "../../store/Store/actions";
import Config from "../../config";
import { usePassport } from "../../context/PassportProvider";
import { openChestAndGetHunterImx } from "../../chain/chestImx";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Lazy]);

const StoredetailImx = ({ chestCount, tier, onChestTypeChanged }) => {
  const defaultVideoUrl = require(`../../assets/videos/T${tier}-Chest-1.mp4`);

  const [openState, setOpenState] = useState(0);
  const [hunterData, setHunterData] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [videoShow, setVideoShow] = useState(true);
  const [altarButtonShow, setAltarButtonShow] = useState(true);
  const [videoUrl, setVideoUrl] = useState(defaultVideoUrl);
  const { address: isWalletConnected, signer: walletClient } = usePassport();

  const videoRef = useRef(null);
  const dispatch = useDispatch();

  const togglePlay = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const getChestThumb = (rarity) => {
    if (![1, 2, 3, 4].includes(rarity)) {
      throw new Error(`Invalid rarity: ${rarity}`);
    }
    if (![2, 3].includes(tier)) {
      throw new Error(`Invalid chest type: ${tier}`);
    }
    return require(`../../assets/videos/T${tier}-Chest-${rarity}.png`);
  };

  const getChestVideo = (rarity, chestType) => {
    if (![1, 2, 3, 4].includes(rarity)) {
      throw new Error(`Invalid rarity: ${rarity}`);
    }
    if (![2, 3].includes(chestType)) {
      throw new Error(`Invalid chest type: ${chestType}`);
    }
    return require(`../../assets/videos/T${chestType}-Chest-${rarity}.mp4`);
  };

  const getButtonLabel = (state) => {
    if (state == 0) return "OPEN";
    if (state == 1) return "PREPARING";
    if (state == 2) return "APPROVING";
    if (state == 3) return "OPENING...";
    if (state == 4) return "PROCESSING";
    if (state == 5) return "TRY AGAIN";
  };

  const loadAndPlayVideo = async () => {
    await videoRef.current?.load();
    togglePlay();
  };

  useEffect(() => {
    if (!hunterData) return;
    console.log({ hunterData });
    setAltarButtonShow(false);
    setVideoUrl(getChestVideo(hunterData?.rarity ?? 1, tier));
    loadAndPlayVideo();
  }, [hunterData]);

  useEffect(() => {
    console.log("Store Detail chestCount useEffect called");
  }, [chestCount]);

  const verifyBetaTester = async () => {
    const response = await axios.get(
      `https://api.boomland.io/api/v1/bridge/beta-tester/${isWalletConnected}`
    );

    return response?.data?.response?.allowed;
  };
  
  const altarHandler = async () => {
    if (openState !== 0 && openState !== 5) return;

    if (!isWalletConnected) return console.log("No wallet connected");

    const signer = walletClient;

    if (signer === undefined) return console.log("No signer");
    const isBetaTester = await verifyBetaTester();
    if (!isBetaTester) return console.error("User is not a beta tester");

    try {
      const openChestResult = await openChestAndGetHunterImx(
        tier,
        signer,
        setOpenState,
        () => {
          const prevCount = Number(
            localStorage.getItem(LOCAL_COUNT_KEY) ?? "0"
          );
          localStorage.setItem(LOCAL_COUNT_KEY, String(prevCount + 1));
          dispatch(IncrementPendingHunters());
        }, true,
      );

      if (openChestResult.success) {
        console.log("HunterData", openChestResult.data);
        setHunterData(openChestResult.data);
      } else {
        console.error(openChestResult.message);
        setOpenState(5);
      }
    } catch (e) {
      console.error(e);
      setOpenState(5);
    }
  };

  const reset = async () => {
    window.location.reload();
    dispatch(decreaseChestCount(tier));
    setHunterData(null);
    setVideoUrl(defaultVideoUrl);
    videoRef.current?.load();
    setAltarButtonShow(true);
    setVideoShow(true);
    setOpenState(0);
  };

  const getTierImage = (tier) => {
    switch(tier) {
      case 2:
        return tier2;
      case 3:
        return tier3;
      default:
        return tier3;
    }
  };

  return (
    <Fragment>
      <div className="video-store-container">
        {altarButtonShow && (
          <div
            className={`btn-chest-rectangle mb-4 mb-lg-0 d-flex align-items-center text-center justify-content-center v-store-img-show`}
          >
            <ChestCount chestCount={chestCount} chestType={tier} />
          </div>
        )}
        <div
          style={{
            width: "100%",
            maxWidth: "1300px",
          }}
        >
          <video
            onLoad={() => {
              "Video loaded";
            }}
            ref={videoRef}
            poster={require(`../../assets/store/background-tier${tier}.png`)}
            className={`video-store ${
              videoShow ? "video-store-show" : "video-store-hide"
            }`}
            onEnded={() => {
              setVideoShow(false);
              togglePlay();
            }}
            muted
          >
            <source src={videoUrl} />
          </video>

          {openState !== 4 && (
            <Box
              sx={{
                width: "30%",
                height: "72%",
                position: "absolute",
                top: "calc(50% - 33%)",
                left: "calc(50% - 16%)",
                "@media screen and (max-width: 650px)": {
                  width: "40%",
                  height: "66%",
                  top: "calc(50% - 43%)",
                  left: "calc(50% - 22%)",
                },
                "@media screen and (min-width: 550px)": {
                  top: "calc(50% - 36%) !important",
                },
              }}
            >
              <Swiper
                spaceBetween={0}
                slidesPerView={1}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                onSlideChange={(swiper) => {
                  console.log(
                    "Store Detail => Swiper onSlideChange called, chestType set to",
                    swiper.activeIndex + 2
                  );
                  onChestTypeChanged(swiper.activeIndex + 2);
                }}
              >
                <SwiperSlide
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={tier2}
                    alt="Tier 2"
                    style={{
                      maxWidth: "79%",
                    }}
                    className="tier2"
                  />
                </SwiperSlide>
                <SwiperSlide
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={tier3}
                    alt="Tier 3"
                    style={{
                      maxWidth: "88%",
                    }}
                    className="tier3"
                  />
                </SwiperSlide>
              </Swiper>
              <div className="swiper-button-prev"></div>
              <div className="swiper-button-next"></div>
              <div
                style={{
                  position: "absolute",
                  top: "31px",
                  right: "39px",
                  width: "47px",
                  height: "58px",
                  backgroundImage: `url(${counter})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 5,
                  fontWeight: "bold",
                }}
                className="chest-counter"
              >
                <span
                  className="chest-counter-font"
                  style={{ color: "white", fontSize: "18px" }}
                >
                  {chestCount}x
                </span>
              </div>
            </Box>
          )}
        </div>

        <div className="btn-buy-openchest btn-buy-now mb-4 mb-lg-0 d-flex align-items-center text-center justify-content-center v-store-img-show">
          <img
            src={greenButton}
            className={` ${
              altarButtonShow ? "v-store-img-show" : "v-store-img-hide"
            }`}
            alt="storedetailimg"
            style={{
              filter: chestCount === 0 ? "grayscale(100%)" : "none",
              cursor: chestCount === 0 ? "not-allowed" : "pointer",
            }}
          />
        </div>
        <div
          onClick={altarHandler}
          className={`btn-open-chest mb-4 mb-lg-0 btn-openchest-bad d-flex align-items-center text-center justify-content-center font-face-bad-blockhead ${
            altarButtonShow ? "v-store-img-show" : "v-store-img-hide"
          } ${openState === 0 ? "btn-open-v-hunter" : ""}`}
          style={{
            pointerEvents: chestCount === 0 ? "none" : "auto",
          }}
          disabled={chestCount === 0}
        >
          {getButtonLabel(openState)}
        </div>

        {hunterData && (
          <img
            src={getChestThumb(hunterData ? hunterData.rarity : 1, tier)}
            className={`video-store-img ${
              videoShow ? "v-store-img-hide" : "v-store-img-show"
            }`}
            alt="storedetailimg"
            style={{
              width: "100%",
              maxWidth: "1300px",
            }}
          />
        )}

        <div
          className={`store-card cursor-pointer ${
            videoShow ? "v-store-img-hide" : "v-store-img-show"
          }`}
          onClick={reset}
        >
          <Storecard
            chestItem={hunterData}
            itemType={"HUNTER"}
            chestType={tier}
          />
        </div>
      </div>
    </Fragment>
  );
};

function ChestCount({ chestCount, chestType }) {
  return (
    <div className="btn-chest-rectangle-text mb-4 mb-lg-0 d-flex align-items-center text-center justify-content-center v-store-img-show font-face-bad-blockhead">
      <p>
        {`Tier ${chestType} Chest`}
      </p>
    </div>
  );
}

export default StoredetailImx;
